import mixin from './mixins'
import Scrollbar from '../scrollbar'

export default {
  name: 'KDataGridBody',
  mixins: [mixin],
  props: {},
  data() {
    return {}
  },
  computed: {
    isEmpty() {
      return this.store.isEmpty
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    handleScroll(scrollInfo) {
      this.layout.apiHandleBodyScroll(scrollInfo)
    },
    renderDefault() {
      if (this.isEmpty) {
        return this.$slots.default
      }
    },
  },
  render() {
    const style = {}

    const css = {
      'km-data-grid__body': true,
    }

    const attrs = {}
    const props = {
      detectScroll: true,
      viewClass: 'km-data-grid__body-view',
    }

    const events = {
      scroll: this.handleScroll,
    }

    const data = {
      style: style,
      props: props,
      class: css,
      attrs: attrs,
      on: events,
    }

    if (this.isEmpty) {
      return (
        <div {...data}>
          {this.renderDefault()}
        </div>
      )
    }

    return (
      <Scrollbar
        ref="scrollBody"
        {...data}>
        {this.renderFixedColumns()}
        {this.renderCenterColumns()}
        {this.renderFixedColumns(true)}
      </Scrollbar>
    )
  },
}
